import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

interface IState {
  supportRightSideMode: number;
  showSupportLeftSide: boolean;
  supportLeftSideMode: number;
  selectedPassenger: number;
  showSupportLeftControl: boolean;
  showPaths: boolean;
  starMiniDashUrl: string;
  starFullDashUrl: string;
}

const initialState: IState = {
  supportRightSideMode: 1,
  showSupportLeftSide: false,
  supportLeftSideMode: 1,
  selectedPassenger: 1,
  showSupportLeftControl: false,
  showPaths: true,
  starMiniDashUrl: "",
  starFullDashUrl: "",
};

export const supportSideSlice = createSlice({
  name: "supportSide",
  initialState,
  reducers: {
    changeSupportRightSideMode: (state, action: PayloadAction<number>) => {
      return { ...state, supportRightSideMode: action.payload };
    },
    changeSupportLeftSideMode: (state, action: PayloadAction<number>) => {
      return { ...state, supportLeftSideMode: action.payload };
    },
    changeShowSupportLeftControl: (state, action: PayloadAction<boolean>) => {
      return { ...state, showSupportLeftControl: action.payload };
    },
    changeSelectedPassenger: (state, action: PayloadAction<number>) => {
      return { ...state, selectedPassenger: action.payload };
    },
    changeShowSupportLeftSide: (state, action: PayloadAction<boolean>) => {
      return { ...state, showSupportLeftSide: action.payload };
    },
    changeShowPaths: (state, action: PayloadAction<boolean>) => {
      return { ...state, showPaths: action.payload };
    },
    setStarMiniDashUrl: (state, action: PayloadAction<string>) => {
      return { ...state, starMiniDashUrl: action.payload };
    },
    setStarFullDashUrl: (state, action: PayloadAction<string>) => {
      return { ...state, starFullDashUrl: action.payload };
    },
  },
});

export const {
  changeSupportRightSideMode,
  changeSupportLeftSideMode,
  changeShowSupportLeftControl,
  changeShowSupportLeftSide,
  changeShowPaths,
  setStarMiniDashUrl,
  setStarFullDashUrl,
  changeSelectedPassenger,
} = supportSideSlice.actions;

export default supportSideSlice.reducer;
